var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-center"},[_c('b-badge',{class:("bg-" + (_vm.chipColor(_vm.params.value))),attrs:{"pill":""}},[_c('span',[_vm._v(_vm._s(_vm.$capitalizeString(_vm.params.value)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }